import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const Icon = (props) => {
  return (props.isImage
    ? (<img src={props.url} className="paragraph-icon" alt="paragraph icon" />)
    : (<span
        className="paragraph-icon"
        style={{ backgroundColor: props.themeColorHex }} >
          <span className={`icon ${props.url}`} />
       </span>)
  )
}

Icon.propTypes = {
  isImage: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default Icon